import script from "./indexList.vue?vue&type=script&setup=true&lang=js"
export * from "./indexList.vue?vue&type=script&setup=true&lang=js"

import "./indexList.vue?vue&type=style&index=0&id=634ba4f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-634ba4f6"]])

export default __exports__